<template>
  <div>
    <GlobalWebsiteStylesAndScripts />
    <LazyLoadInit />

    <ContentBuilderCustomScripts v-if="state.isContentBuilderVisible" />
    <LightBoxInit v-if="state.isContentBuilderVisible" />

    <CollectionPagesScriptsAndStyles v-if="state.isCollectionPagesVisible" />
    <SearchPageScriptsAndStyles v-if="state.isSearchPageVisible" />

    <TutcoImmediateAssistanceModal />
    <MailChimpSignUpFormModal />

    <NotificationsComponent v-if="notificationsStore.notifications.length > 0" />
  </div>
</template>

<script setup lang="ts">
import { defineAsyncComponent, onMounted, reactive } from 'vue';
import GlobalPreloaderHelper from '@/helpers/global/globalPreloader.helper';
import useNotificationsStore from '@/store/notifications';

const GlobalWebsiteStylesAndScripts = defineAsyncComponent(() => import('@/components/website/global/GlobalWebsiteStylesAndScripts.vue'));
const LazyLoadInit = defineAsyncComponent(() => import('@/components/global/LazyLoadInit.vue'));

const ContentBuilderCustomScripts = defineAsyncComponent(() => import('@/components/website/content-builder/ContentBuilderCustomScripts.vue'));
const LightBoxInit = defineAsyncComponent(() => import('@/components/website/content-builder/LightBoxInit.vue'));

const CollectionPagesScriptsAndStyles = defineAsyncComponent(
  () => import('@/components/website/collection-pages/CollectionPagesScriptsAndStyles.vue')
);
const SearchPageScriptsAndStyles = defineAsyncComponent(() => import('@/components/website/search-page/SearchPageScriptsAndStyles.vue'));

const TutcoImmediateAssistanceModal = defineAsyncComponent(() => import('@/components/website/modals/TutcoImmediateAssistanceModal.vue'));
const MailChimpSignUpFormModal = defineAsyncComponent(() => import('@/components/website/modals/MailChimpSignUpFormModal.vue'));

const NotificationsComponent = defineAsyncComponent(() => import('@/components/global/notifications/NotificationsComponent.vue'));

const notificationsStore = useNotificationsStore();

const state = reactive({
  isContentBuilderVisible: false,
  isCollectionPagesVisible: false,
  isSearchPageVisible: false,
});

onMounted(() => {
  GlobalPreloaderHelper.init();

  state.isContentBuilderVisible = document.querySelector('.content-builder-area') !== null;
  state.isCollectionPagesVisible = IS_COLLECTION_PAGE_VISIBLE;
  state.isSearchPageVisible = IS_SEARCH_PAGE_VISIBLE;
});
</script>
